import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import {WindowWidthProvider} from "./Context/WindowWidthContext";
import {MobileProvider} from "./Context/MobileContext";

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    <React.StrictMode>
        <WindowWidthProvider>
            <MobileProvider>
                <App/>
            </MobileProvider>
        </WindowWidthProvider>
    </React.StrictMode>
);
